import { generateEvent } from '../../../utils/dataGrinch';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';

export function tiggerEventOnCategorySelection({
  nativeCategoryPageId,
  nativeCategoryName,
  nativeCategoryType
}) {
  generateEvent({
    Event: 'TopLevelCategorySelection',
    value: {
      LinkUrl: nativeCategoryPageId,
      LinkName: nativeCategoryName,
      Type: nativeCategoryType
    }
  });
  cleverTapPushEvent({
    eventName: CLEVERTAP_EVENT_NAMES.Category_selected,
    eventObj: {
      type: nativeCategoryType,
      name: nativeCategoryName
    }
  });
}

export function tiggerEventOnCategoryChanged({ nativeCategoryName, nativeCategoryType }) {
  cleverTapPushEvent({
    eventName: CLEVERTAP_EVENT_NAMES.Category_changed,
    eventObj: {
      type: nativeCategoryType,
      name: nativeCategoryName
    }
  });
}
